// extracted by mini-css-extract-plugin
module.exports = {"offices":"styles_offices__3F2H4"};